export class Claimant {
  reimbursementForLossTime: any;
  lossTimeHours: any;
  uniqueId: string;
  noticeId: string;
  emailAddress: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: any;
  dateCreated: any;
  primaryPhone: string;
  secondaryPhone: string;
  primaryPhoneType: string;
  secondaryPhoneType: string;
  country: string;
  province: string;
  agreeance: string;
  signature: string;
  claimNumber: string;
  wasClaimantNoticed: any;
  name1: string;
  companyName: string;
  claimStartTime: any;
  claimEndTime: any;
  googleRecaptchaToken: string;
  ClaimDetails: ClaimDetails[];
}

export class ClaimDetails {
  id: number;
  claimNumber: any;
  period: string;
  broilerCategoryPart: string;
  purchaseAmount: string;
}

